import { render } from "./BusinessReceiptInvoicesModal.vue?vue&type=template&id=21d444ba&scoped=true&ts=true"
import script from "./BusinessReceiptInvoicesModal.vue?vue&type=script&lang=ts"
export * from "./BusinessReceiptInvoicesModal.vue?vue&type=script&lang=ts"

import "./BusinessReceiptInvoicesModal.vue?vue&type=style&index=0&id=21d444ba&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d444ba"]])

export default __exports__